export function setListCommitmentsData(state, payload) {
    const newState = { 
      ...state,
      ListCommitments: {
        ...state.ListCommitments,
        data: payload
      }
    };
    return newState
  }

  export function setListCommitmentsStatus(state, status) {
    return {
      ...state,
      ListCommitments: {
        ...state.ListCommitments,
        status: status
      }
    };
  }